export default {
  'Resolution': 'Risoluzione',
  'Frame rate': 'velocità in fotogrammi',
  'The higher the frame rate, the smoother the animation': "La velocità in fotogrammi più alto, l'animazione è più fluida.",
}